import { useEffect, useRef } from 'react';

/** Calls `onEscape` whenever the Escape key is pressed (while enabled). */
export const useOnEscape = (onEscape: () => void, enabled = true) => {
  const onEscapeRef = useRef(onEscape);
  onEscapeRef.current = onEscape;

  useEffect(() => {
    if (!enabled) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onEscapeRef.current();
    };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [enabled]);
};
